export const products = [
  {
    id: "svc-web",
    type: "service",
    image: "https://images.unsplash.com/photo-1764452008254-eed469a4fad3?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    price: { try: 185000, usd: 5400 },
    tag: { tr: "Mimari", en: "Architecture" },
    name: { tr: "Ultra Web Mimarisi", en: "Ultra Web Architecture" },
    desc: { tr: "Kurumsal ölçekte, headless ve ışık hızında web platformu.", en: "Enterprise-grade headless web platform engineered for speed." },
    specs: ["Headless", "Edge CDN", "A11y AA"],
  },
  {
    id: "hw-key",
    type: "hardware",
    image: "https://images.unsplash.com/photo-1504610926078-a1611febcad3?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    price: { try: 12900, usd: 390 },
    tag: { tr: "Güvenlik", en: "Security" },
    name: { tr: "Quantum Key Pro", en: "Quantum Key Pro" },
    desc: { tr: "Titanyum gövdeli, FIDO2 uyumlu kurumsal güvenlik anahtarı.", en: "Titanium-bodied FIDO2 enterprise security key." },
    specs: ["FIDO2", "NFC", "Titanium"],
  },
  {
    id: "svc-ai",
    type: "service",
    image: "https://images.unsplash.com/photo-1625314887424-9f190599bd56?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    price: { try: 240000, usd: 7000 },
    tag: { tr: "Yapay Zekâ", en: "AI" },
    name: { tr: "AI Kurumsal Otomasyon", en: "AI Corporate Automation" },
    desc: { tr: "Özel LLM ajanları ile iş akışlarınızı uçtan uca otomatize edin.", en: "End-to-end workflow automation with bespoke LLM agents." },
    specs: ["LLM Agents", "RAG", "SOC2"],
  },
  {
    id: "hw-station",
    type: "hardware",
    image: "https://images.unsplash.com/photo-1536242918817-db5e93c7a0e4?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    price: { try: 89000, usd: 2650 },
    tag: { tr: "Donanım", en: "Hardware" },
    name: { tr: "Apex Dev Station", en: "Apex Dev Station" },
    desc: { tr: "Mat siyah, sessiz soğutmalı yüksek performans geliştirici istasyonu.", en: "Matte black, silent-cooled high-performance developer station." },
    specs: ["64GB", "Silent", "Thunderbolt 5"],
  },
  {
    id: "svc-seo",
    type: "service",
    image: "https://images.unsplash.com/photo-1720962158789-9389a4f399da?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    price: { try: 68000, usd: 1990 },
    tag: { tr: "Büyüme", en: "Growth" },
    name: { tr: "SEO Hâkimiyeti", en: "SEO Supremacy" },
    desc: { tr: "Teknik SEO, içerik mimarisi ve küresel sıralama stratejisi.", en: "Technical SEO, content architecture and global ranking strategy." },
    specs: ["Technical", "Content", "Global"],
  },
  {
    id: "svc-brand",
    type: "service",
    image: "https://images.pexels.com/photos/28506813/pexels-photo-28506813.jpeg?auto=compress&cs=tinysrgb&w=900",
    price: { try: 120000, usd: 3500 },
    tag: { tr: "Marka", en: "Brand" },
    name: { tr: "Özel Marka Kimliği", en: "Bespoke Brand Identity" },
    desc: { tr: "Logo, tipografi ve kurumsal kimlik sistemi; lüks standartlarda.", en: "Logo, typography and identity system to luxury standards." },
    specs: ["Logo", "System", "Guidelines"],
  },
];
